module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/img-35abf8559dede7c6e17d4cf6a422a5c4.png";